import { ArrowRight } from "lucide-react";
import { useAdvisor } from "@/advisor/AdvisorContext";
import { StepShell } from "./StepShell";
import { OptionGrid } from "./OptionGrid";

export const StepGoals = ({ onNext, onBack }) => {
  const { state, update, meta } = useAdvisor();
  const goals = meta?.goals || [];
  const label = state.business?.key === "other" ? "Biznesiniz" : `${state.business?.label} biznesi`;

  const toggle = (k) => {
    if (k === "all") return update({ goals: state.goals.includes("all") ? [] : goals.map((g) => g.key) });
    const next = state.goals.includes(k) ? state.goals.filter((x) => x !== k && x !== "all") : [...state.goals, k];
    update({ goals: next });
  };

  return (
    <StepShell
      testid="advisor-step-goals" step={1} total={2} onBack={onBack}
      intro={`Əla. ${label} üçün bir neçə faydalı rəqəmsal həll təklif edə bilərik.`}
      title="Əsas məqsədiniz nədir?" subtitle="Bir neçə variant seçə bilərsiniz"
      footer={
        <button className="adv-btn w-full" disabled={!state.goals.length} onClick={onNext} data-testid="btn-step1-next">
          Davam et <ArrowRight className="h-5 w-5" />
        </button>
      }
    >
      <OptionGrid options={goals} value={state.goals} onToggle={toggle} prefix="goal-card" />
    </StepShell>
  );
};
